import { SearchIcon } from "@heroicons/react/solid"
import { HttpError, useOne } from "@refinedev/core";
import Button from "components/button"
import Input from "components/input"
import Select from "components/select";
import { useState } from "react";
import { ATTRACTION_QR_CODE_SENDING_STATUS, STATUS_OPTIONS } from "utills/constants";

export const Filter = ({ currentFilterValues, setFilters}: {currentFilterValues: any, setFilters: any}) => {
  const [keyword, setKeyword] = useState(currentFilterValues.q);
  const [eventId, setEventId] = useState(currentFilterValues.event_id);
  const [status, setStatus] = useState(currentFilterValues.status);
  const [isActive, setIsActive] = useState(currentFilterValues.is_active);
  const [ticketId, setTicketId] = useState(currentFilterValues.ticket_id);

  const { data, isLoading } = useOne<any[], HttpError>({
    resource: "content/dropdown/events?v=2&event_type=attractions",
    id: "",
    meta: {
      resource: "data"
    }
  });

  const { data: ticketsData, isFetching: isFetchingTicketsData } = useOne<any[], HttpError>({
    resource: `content/events/${eventId}/tickets/dropdown`,
    id: "",
    meta: {
      resource: "data"
    },
     queryOptions: {
      enabled: !!eventId
     } as any
  });

  const eventIds = (data?.data ?? []).map((event: {id: string; name_en: string}) => (
    { value: event.id, label: event.name_en }
  ));

  const ticketIds = ((ticketsData?.data) ?? []).map((event: {id: string; type_name_en: string}) => (
    { value: event.id, label: event.type_name_en }
  ));
  
  const _handleSubmitFilter = () => {
    setFilters([
      {field: "q", operator: "contains", value: keyword},
      {field: "event_id", operator: "eq", value: eventId},
      {field: "status", operator: "eq", value: status},
      {field: "is_active", operator: "eq", value: isActive},
      {field: "ticket_id", operator: "eq", value: ticketId},
      {field: "page", operator: "eq", value: 1}
    ])
  }

  return (
    <div className="w-full flex flex-col gap-y-4">
      <div className="w-full flex flex-col gap-y-4 md:flex-row md:items-end md:gap-x-3">
        <div className="flex-1">
          <label htmlFor="name" className="block text-sm font-medium leading-6">
            Search
          </label>
          <div className="mt-2">
            <Input 
              className="px-2 py-2"
              label='Search'
              id='name'
              type="text"
              placeholder="Search by code"
              value={keyword}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => setKeyword(e.target.value)}
              onKeyDown={(e: React.KeyboardEvent) => {
                if (e.key === 'Enter') {
                  _handleSubmitFilter();
                }
              }}
            />
          </div>
        </div>
        <div className="flex-1">
          <label htmlFor="status" className="block text-sm font-medium leading-6">
          Code sending status
          </label>
          <div className="mt-2">
            <Select
              options={ATTRACTION_QR_CODE_SENDING_STATUS}
              isClearable={true}
              id="status"
              placeholder="Select code sending status"
              className="py-0.5"
              value={ATTRACTION_QR_CODE_SENDING_STATUS.find((d) => d.value === status)}
              onChange={(selected: {label: string; value: string}) => setStatus(selected?.value)}
            />
          </div>
        </div>
        <div className="flex-1">
          <label htmlFor="is_active" className="block text-sm font-medium leading-6">
            Status
          </label>
          <div className="mt-2">
            <Select
              options={STATUS_OPTIONS}
              isClearable={true}
              id="is_active"
              placeholder="Select status"
              className="py-0.5"
              value={STATUS_OPTIONS.find((d) => d.value === isActive)}
              onChange={(selected: {label: string; value: string}) => setIsActive(selected?.value)}
            />
          </div>
        </div>
      </div>
      <div className="w-full flex flex-col gap-y-4 md:flex-row md:items-end md:gap-x-3">
        <div className="flex-1">
          <label htmlFor="event_id" className="block text-sm font-medium leading-6">
            Event name
          </label>
          <div className="mt-2">
            <Select
              options={eventIds}
              isLoading={isLoading}
              isClearable={true}
              id="event_id"
              placeholder="Select event name"
              className="py-0.5"
              value={eventIds.find((d) => d.value === eventId)}
              onChange={(selected: {label: string; value: string}) => {
                setEventId(selected?.value);
                setTicketId("");
              }}
            />
          </div>
        </div>
        <div className="flex-1">
          <label htmlFor="ticket_id" className="block text-sm font-medium leading-6">
            Ticket name
          </label>
          <div className="mt-2">
            <Select
              key={`ticket_id__${eventId ?? "all"}`}
              isClearable={true}
              options={eventId ? ticketIds : []}
              isLoading={isFetchingTicketsData}
              id="ticket_id"
              placeholder="Select ticket mame"
              className="py-0.5"
              value={ticketIds.find((d) => d.value === ticketId)}
              onChange={(selected: {label: string; value: string}) => setTicketId(selected?.value)}
            />
          </div>
        </div>
        <div className="shrink-0">
          <label htmlFor="search" className="block text-sm font-medium leading-6">
            <span className="sr-only">Search</span>
          </label>
          <div className="mt-2 w-full">
            <Button type="submit" className="w-full bg-white rounded-md px-3 text-brand-500 py-2 border-solid border-brand-500 border-[1px] hover:bg-white active:bg-white active:opacity-85" onClick={_handleSubmitFilter}>
              <SearchIcon className="w-3 h-4 text-brand-500 mr-2" /> Search
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}